const $ = jQuery.noConflict()

function open(item) {
    let content = $(item).find('.block-memberdues__info-popup-content').text(),
        itemParent = $(item).closest('.block-memberdues'),
        scrollTop = itemParent.offset().top,
        elementOffset = $(item).offset().top,
        distance = elementOffset - scrollTop;

    $('.block-memberdues__info-popup-modal--active').removeClass(
        'block-memberdues__info-popup-modal--active'
    )

    $(item)
        .closest('.block-memberdues')
        .find('.block-memberdues__info-popup-modal-content')
        .text(content)

    $(item)
        .closest('.block-memberdues')
        .find('.block-memberdues__info-popup-modal')
        .css('top', distance)
        .addClass('block-memberdues__info-popup-modal--active')
        
    let modalPos = elementOffset - scrollTop + $(item).closest('.block-memberdues').find('.block-memberdues__info-popup-modal').height();

    if(modalPos > itemParent.height()) {
        console.log('translateY(calc(-100% - 50px + ' + $(item).closest('.block-memberdues__tbody-row').height() + 'px))');
        $(item)
        .closest('.block-memberdues')
        .find('.block-memberdues__info-popup-modal')
        .css('transform', 'translateY(calc(-100% - 30px + ' + $(item).closest('.block-memberdues__tbody-row').height() + 'px))')
    }
}

function close(item) {
    $(item)
        .closest('.block-memberdues__info-popup-modal')
        .removeClass('block-memberdues__info-popup-modal--active')
}

function tablePopupInit() {
    $('.block-memberdues__info-popup-button').on('click', function () {
        open(this)
    })

    $('.block-memberdues__info-popup-modal-close').on('click', function () {
        close(this)
    })
}

export default tablePopupInit()
